import Vue from 'vue';
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
  setInteractionMode,
} from 'vee-validate';

import defaultLocale from '@/assets/locale/es.json';
import * as rules from 'vee-validate/dist/rules';

import { i18n } from '@/i18n.js';

Vue.component('validation-provider', ValidationProvider);
Vue.component('validation-observer', ValidationObserver);

Object.keys(rules).forEach((rule) => {
  let ruleObj = {
    ...rules[rule], // copies rule configuration
    message: defaultLocale.messages[rule], // assign message
  };
  extend(rule, ruleObj);
});

localize('en', defaultLocale);

extend('url', {
  validate: (str) => {
    var pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i'
    ); // fragment locator
    return !!pattern.test(str);
  },
  message: 'No es una URL válida',
});

extend('money', {
  validate: (value) => {
    if (value == null || value == undefined) return false;

    let regex = /^\d*\.?\d*$/g;

    return value.toString().search(regex) !== -1;
  },
});

extend('ssn', {
  getMessage: () => 'El número de seguro social entrado no es valido.',
  validate: (value) => {
    if (value == null || value == undefined) return false;

    let regex = /^\d{3}-\d{2}-\d{4}$/g;

    return value.search(regex) !== -1;
  },
});

extend('hasNumberLettersPassword', (value) => {
  let regex = /^(?=.*[0-9])(?=.*[a-zA-Z]).+$/;
  if (value.search(regex) !== -1) return true;

  return i18n.locale == 'en'
    ? 'The password must include at least one letter and one number.'
    : 'La contraseña debe incluir mínimo una letra y un número.';
});

extend('hasCorrectSizeCPassword', (value) => {
  let regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{6,16}$/g;
  if (value.search(regex) !== -1) return true;
  return 'Este campo no debe ser menor de 6 caracteres ni mayor a 16 caracteres.';
});

extend('hasCorrectSizePassword', (value) => {
  let regex = /^.{6,16}$/g;
  if (value.search(regex) !== -1) return true;
  return i18n.locale == 'en'
    ? 'This field must not be less than 6 characters or greater than 16 characters.'
    : 'Este campo no debe ser menor de 6 caracteres ni mayor a 16 caracteres.';
});

extend('isEqualToCPassword', (value, args) => {
  if (args.length > 0) {
    if (value === args[0]) return true;
  }
  return i18n.locale == 'en'
    ? 'This password must be identical to the input in the new password field.'
    : 'Esta contraseña debe ser igual a la entrada en el campo de nueva contraseña.';
});

extend('mustBeDifferentThanCPassword', (value, args) => {
  if (args.length > 0) {
    if (value !== args[0]) return true;
  }
  return 'La contraseña nueva no puede ser igual a la anterior.';
});

extend('differentFromZero', (value) => {
  if (!isNaN(value) && value != 0) return true;
  return 'Favor de añadir un valor diferente de cero';
});

extend('greaterThanZero', (value) => {
  if (!isNaN(value) && value >= 0) return true;
  return 'Favor de añadir un valor mayor de cero';
});

extend('notEmptyObject', (value, args) => {
  if (args.length > 0) {
    const key = args[0];
    if (value[key] > 0 && value[key] !== '') return true;
  }
  return 'El campo es requerido';
});

setInteractionMode('eager');
